'use client';

import useFormFillPage from '@/hooks/use-form-fill-page';
import { Edit } from 'lucide-react';

import { useState } from 'react';

import { useRouter } from '@shared/hooks/use-router';
import { Button } from '@/components/ui/button';

import { LoggedInUserMenu, Tooltip } from '@/shared/components';
import { COPY } from '@/shared/constants/copies';

import { getFormEditPath } from '@/utils/common';

import { useFormEditAccess } from '../../hooks/use-form-edit-access';
import LoginModal from './auth/login-modal';

function FormFillingHeaderSection() {
	const [openLoginModal, setOpenLoginModal] = useState(false);
	const { hasAccess } = useFormEditAccess();
	const router = useRouter();

	const {
		updatedFormFillDetails,
		updatedUserDetails: userDetails,
		invalidateUserRelatedQueries,
		resetUserRelatedQueries,
	} = useFormFillPage();

	const formId = updatedFormFillDetails?.id;
	const displayProfileAvatar = !!userDetails;

	const handleLoginSuccess = async () => {
		setOpenLoginModal(false);
		await invalidateUserRelatedQueries();
	};

	const handleClick = () => {
		if (formId) {
			router.push(getFormEditPath(formId));
		}
	};

	return (
		<div className="flex w-full items-center justify-between gap-6 p-6 pb-0 md:h-16">
			{displayProfileAvatar && (
				<div className="ml-auto flex items-center gap-3">
					{hasAccess && formId && (
						<Tooltip text={COPY.access.manageAccess('form')}>
							<Button
								size="sm"
								variant="light"
								onClick={(e) => {
									e.stopPropagation();
									handleClick();
								}}
							>
								<Edit className="h-3.5 w-3.5" />
								Edit
							</Button>
						</Tooltip>
					)}
					<LoggedInUserMenu onLogoutSuccess={resetUserRelatedQueries} />
				</div>
			)}

			{openLoginModal && (
				<LoginModal
					open={openLoginModal}
					onOpenChange={setOpenLoginModal}
					onLoginSuccess={handleLoginSuccess}
				/>
			)}
		</div>
	);
}

export default FormFillingHeaderSection;
